<div class="card dialog-box">
  <div class="card-header">
    {{ updateView ? "Edit Client Details" : "Add New Client" }}
    <span class="float-end" (click)="onCloseDialogue()">
      <i class="fa-solid fa-xmark"></i>
    </span>
  </div>
  <div class="row row-cols-1 mb-4">
    <form [formGroup]="clientForm" appFormEnterAction>
      <div class="mb-2">
        <gtapp-input-field
          dtValue="Client Name"
          inputId="clientField"
          [maxLength]="256"
          [inputStringValue]="clientForm.value.company_name"
          (blurEmit)="clientForm.controls['company_name'].setValue($event)"
        >
        </gtapp-input-field>
      </div>

      <div class="d-flex align-items-center gap-2 mb-3">
        <div class="form-check">
          <input
            class="form-check-input"
            type="checkbox"
            id="checkDefault"
            [checked]="addManualAddress"
            (change)="
              addManualAddress = !addManualAddress;
              clientForm.controls['custom_address'].setValue('');
              addressForm.patchValue(addressFormBackup)
            "
          />
        </div>
        <div>
          <label class="form-check-label" for="checkDefault" role="button">
            Enter Address Manually
          </label>
        </div>
      </div>

      @if (addManualAddress) {
        <input
          class="form-control"
          rows="1"
          type="text"
          wrap="hard"
          maxlength="256"
          placeholder=""
          formControlName="custom_address"
        />
      }
    </form>
  </div>
  <div class="row row-cols-2">
    <div>
      <button
        type="button"
        class="btn btn-dark w-100 btn-lg"
        (click)="onCloseDialogue()"
      >
        Cancel
      </button>
    </div>
    <div>
      <button
        type="button"
        class="btn btn-primary w-100 btn-lg"
        (click)="updateData()"
        [disabled]="!clientForm.valid"
      >
        Submit
      </button>
    </div>
  </div>
</div>
